import React, {useRef, useState, } from 'react';
import {genereteKey} from '../../../../utils/common';
import {getIncorectField} from '../../../../utils/parserForm';

export const SimpleForm = ({handleSubmit = () => {}, children, shouldResetOnSuccess = false}) => {
  const formRef = useRef();
  const [key, setKey] = useState(genereteKey());

  const _handleSubmit = (evt) => {
    evt.preventDefault();
    evt.stopPropagation()
    const incorectElem = getIncorectField(evt)

    if (incorectElem) {
      incorectElem.focus();
      
      return;
    }

    let formShouldReset = false;

    new Promise((resolve, reject) =>{
      // Создаем custom resolve функцию, которая помечает форму для сброса
      const customResolve = (result) => {
        formShouldReset = true;
        resolve(result);
      };

      // Создаем custom reject функцию, которая НЕ сбрасывает форму
      const customReject = (error) => {
        formShouldReset = false;
        reject(error);
      };

      try {
        const result = handleSubmit(evt, customResolve, customReject);
        
        // Если handleSubmit возвращает Promise, обрабатываем его
        if (result && typeof result.then === 'function') {
          result
            .then((response) => {
              // Проверяем, есть ли ошибки валидации в ответе
              if (response && response.res && (response.res.code || response.res.code === 0)) {
                // Есть ошибки валидации - не сбрасываем форму
                customReject(response);
              } else {
                // Успешный результат - можно сбросить форму если shouldResetOnSuccess = true
                if (shouldResetOnSuccess) {
                  customResolve(response);
                } else {
                  resolve(response);
                }
              }
            })
            .catch((error) => {
              // Ошибка - не сбрасываем форму
              customReject(error);
            });
        } else {
          // Если функция не возвращает Promise и не вызвала resolve/reject,
          // не сбрасываем форму автоматически
          resolve(result);
        }
      } catch (error) {
        customReject(error);
      }
    }).then((result)=>{
      // Сбрасываем форму только если это было явно указано через customResolve
      if (formShouldReset && formRef.current) {
        formRef.current.reset();
        setKey(genereteKey());
      }
    }).catch(err=>{
      // При ошибках валидации не сбрасываем форму, только логируем
      console.log('Form submission error:', err)
    })
  }
  
  return(
    <form onSubmit={_handleSubmit} ref={formRef} key={key} noValidate>
      {children}
    </form>
  )
}